export default "__VITE_ASSET__DwwYU1DR__"